import React, { useState } from "react";
import { getCardImage } from "../../resultVisuals/cardAssets";
import CardImg from "../../../../components/CardImg";

/**
 * Teenpatti - 2.0 (casino/teen6) video overlay — reference markup (.casino-table.teenpatti2):
 *   .casino-video-cards[.hide-cards] > .casino-cards-shuffle + .casino-video-cards-container
 *     > div(cards[0], cards[2], cards[4]) + div(cards[1], cards[3], cards[5])
 * Rendered whenever the round has a card string; collapsed (.hide-cards) while cards[0] is "1"
 * (not dealt) or after the shuffle handle is clicked, like the reference.
 */
export default function Teen6CardsOverlay({ card }) {
  const [showCards, setShowCards] = useState(true);
  if (card == null || card === "") return null;
  const cards = String(card).split(",").map((c) => c.trim());
  const hide = !showCards || cards[0] === "1";
  if (cards[0] === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  const row = (idx) =>
    idx.map((i, k) => (
      <React.Fragment key={i}>
        {k > 0 ? " " : null}
        <span>
          <CardImg src={getCardImage(cards[i] || "1")} alt="" />
        </span>
      </React.Fragment>
    ));

  return (
    <div className={`casino-video-cards${hide ? " hide-cards" : ""}`}>
      <div className="casino-cards-shuffle" onClick={() => cards[0] !== "1" && setShowCards((v) => !v)}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        <div>{row([0, 2, 4])}</div> <div>{row([1, 3, 5])}</div>
      </div>
    </div>
  );
}
